import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const LocalizationTextOverrideSchema_ = z.object({
  _id: z.string(),
  localizationGroupId: z.string(),
  localizationObjectId: z.string(),
  path: z.string(),
  text: z.string(),
});

export const LocalizationTextOverrideSchema: z.ZodType<LocalizationTextOverrideSchema> =
  LocalizationTextOverrideSchema_;
export interface LocalizationTextOverrideSchema
  extends z.infer<typeof LocalizationTextOverrideSchema_> {}

const WidgetInfoSchema_ = z.object({
  name: z.string(),
  localizationId: z.string(),
  elementType: z.string(),
});

export const WidgetInfoSchema: z.ZodType<WidgetInfoSchema> = WidgetInfoSchema_;
export interface WidgetInfoSchema extends z.infer<typeof WidgetInfoSchema_> {}

export const getLocalizationTextOverrides = {
  name: "getLocalizationTextOverrides" as const,
  input: z.object({
    teamId: zExt.objectId(),
    localizationGroupId: zExt.objectId(),
  }),
  output: z.object({
    widgetInfo: z.array(WidgetInfoSchema),
    localizationTextOverrides: z.array(LocalizationTextOverrideSchema),
  }),
};
